import React from "react";
import MangeJobs from "./index";
function ManageJob() {
  return (
    <div className="p-4">
      <MangeJobs />
    </div>
  );
}

export default ManageJob;
